import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"head-row engagement-wrapper\">\n    <div class=\"engagement-image\" aria-hidden=\"true\">\n        "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"interchange") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":4,"column":37}}}))
    + "\n    </div>\n</div>\n<div class=\"small-12 column background-styles\">\n    <div id=\"outer-box\">\n        <div class=\"trans-box\">\n            <div class=\"row\">\n                <div class=\"large-offset-1 medium-offset-1 large-7 medium-7 column article-title\">\n                    <div class=\"overlay-extend\"></div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLine") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":20},"end":{"line":15,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLineHomeBuyer") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":20},"end":{"line":18,"column":27}}})) != null ? stack1 : "")
    + "                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <h2 class=\"stickytarget cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLine") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <h2 class=\"stickytarget homebuyer cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLineHomeBuyer") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row no-image\">\n    <div class=\"large-offset-1 medium-offset-1 small-offset-0 large-7 medium-7 small-12 column article-title \">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLine") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":8},"end":{"line":30,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <h2 class=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLine") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"interchange") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":33,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/engagement-area-module",
  "version": "1.0.2",
  "id": "engagement-area-module",
  "containerID": "homeLoansEngagementAreaModule",
  "moduleName": "home-loans-engagement-area-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "engagement-area-module",
  "data": {
    "init": "engagementAreaModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        picture
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    picture
  },
  "dependencies": {
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/**
 * @export
 * @class engagementAreaModule
 * @extends {Module}
 */
class engagementAreaModule extends Module {
  /**
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
  * @return {void}
  */
  init() {
    // update links to handle subcampaign codes and
    // secure ones (prequality now, apply now, and schedule an appt)
    const $cache = $('div[id*="cta"] a[id*="ScheduleAppointment"],' // schedule appt cta
    + '#contactUsModule a#schedule-appt,' + ' .apply-now, ' + '#globalFooterModule .get-prequalified'); // schedule appt contact us

    $.each($cache, (idx, val) => {
      const link = spaParams.siteParams.secureHost + $(val).attr('href');
      $(val).attr('href', link);
    });
  }
}
registerModuleClass({
  moduleClass: engagementAreaModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { engagementAreaModule as default, moduleConfig };
